import { Divider } from "@mui/material";
import { format } from "date-fns";
import dayjs from "dayjs";
import timezone from "dayjs/plugin/timezone";
import React from "react";
import Helper from "../../Helper";
import { CommandListDelivery, CommandProjectInfo } from "../CommandTypes";

dayjs.extend(timezone);

interface CommandListViewDateSectionProps {
    label?: string;
    date: Date;
    deliveries: CommandListDelivery[];
    project: CommandProjectInfo;
}

const CommandListViewDateSection: React.FC<CommandListViewDateSectionProps> = ({
    label,
    date,
    deliveries,
    project,
}) => {
    const dropOffAreaAvatar = (delivery: any) => {
        if (!delivery?.drop_off_area) {
            return null;
        }

        const avatar = Helper.areaAvatar(delivery.drop_off_area, delivery.drop_off_area_map_object);

        return (
            <div className="flex items-center text-nowrap gap-1">
                {avatar}
                <span className="truncate">{delivery.drop_off_area.area_name}</span>
            </div>
        );
    };

    const equipmentAvatar = (delivery: CommandListDelivery) => {
        if (!delivery?.equipment || !delivery?.equipment_map_object) {
            return null;
        }

        const avatar = Helper.equipmentAvatar(delivery.equipment_map_object as any);

        return (
            <div className="flex items-center text-nowrap gap-1">
                {avatar}
                <span className="truncate">{delivery.equipment.equipment_name}</span>
            </div>
        );
    };

    const vehicleLabel = (delivery: CommandListDelivery): React.ReactNode => {
        if (delivery.vehicle_quantity > 1) {
            return <span className="mx-1">({delivery.vehicle_quantity})</span>;
        }

        return null;
    };

    const renderDelivery = (delivery: CommandListDelivery, renderFuture: boolean = false) => {
        const startAt = dayjs(delivery?.start_at)?.tz(project.timezone);
        return (
            <div key={delivery.id} className="flex flex-row items-center justify-between text-plot-white">
                <div
                    className={Helper.classNames(
                        "text-nowrap font-bold text-center w-1/6",
                        startAt?.format("LTS").length == 10 && "pl-2"
                    )}
                >
                    {renderFuture ? startAt?.format("MM/dd h:mm A") : startAt?.format("h:mm A")}
                </div>
                <div className="flex flex-row items-center w-1/4 text-left">
                    <img
                        src={delivery.receiving_team?.avatar_url}
                        alt={delivery.receiving_team?.team_name}
                        className="w-5 h-5 rounded-full"
                    />
                    <span className="ml-2 truncate">{delivery.receiving_team?.team_name}</span>
                </div>
                <div className="font-bold text-left w-1/3">
                    <span className="truncate">{delivery.name}</span>
                    {vehicleLabel(delivery)}
                </div>
                <div className="w-1/5">{dropOffAreaAvatar(delivery)}</div>
                <div className="w-1/5">{equipmentAvatar(delivery)}</div>
            </div>
        );
    };

    return (
        <>
            <Divider>
                <span className=" font-plot-open-sans text-lg text-plot-orange ">
                    {label && `${label}, `}
                    {`${format(date, "MMM do ")}`}
                </span>
            </Divider>
            <div className="flex flex-col gap-2">
                {deliveries.length > 0 ? (
                    deliveries.map((delivery) => renderDelivery(delivery))
                ) : (
                    <div className="w-full text-center text-lg italic text-plot-light-grey ">No Deliveries {label}</div>
                )}
            </div>
        </>
    );
};

export default CommandListViewDateSection;
